export default {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  button: {
    backgroundColor: '#EE4360',
    color: 'white',
    width: 150,
    height: 50,
    fontSize: 16,
    whiteSpace: 'nowrap',
    '& + *': {
      marginLeft: 24,
    },
    '&:hover': {
      backgroundColor: '#EE4360',
    },
  },
}



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/styles.js